<template>
    <div class="view view__session_register_print">
        <session-register-print/>
    </div>
</template>

<script>
import SessionRegisterPrint from '@/components/ebs/sessions/register/SessionRegisterPrint'

export default {
  components: {
    SessionRegisterPrint
  },
  name: 'view-session-register-print',
  computed: {
    routeRegisterId () {
      return this.$route.params.registerId
    },
    routeSessionId () {
      return this.$route.params.sessionId
    }
  },
  methods: {
    getRegister () {
      const registerId = this.$route.params.registerId
      return this.$store.dispatch('getRegister', registerId)
    },
    getSession () {
      const sessionID = this.$route.params.sessionId
      return this.$store.dispatch('getSession', sessionID)
    },
    toPrintBack () {
      setTimeout(() => this.$eventBus.$emit('print-register'), 100)
    }
  },
  created () {
    let requestsArr = []
    let requestsCounter = 0

    requestsArr.push(this.getRegister)
    requestsArr.push(this.getSession)

    for (let fn of requestsArr) {
      fn().finally(() => {
        requestsCounter++
        if (Number(requestsCounter) === Number(requestsArr.length)) {
          this.toPrintBack()
        }
      })
    }
  },
  beforeDestroy () {
    this.$store.dispatch('resetRegister')
  }
}
</script>
